export default __webpack_public_path__ + "static/media/Web Design CERT.1af95725.png";